export const zIndex = {
  under: -1,
  bottomLayer: 1,
  overContent: 11,
  overContentMenu: 12,
  overSideMenu: 13,
  overlayMenu: 14,
};

export const animationDuration = {
  fast: 150,
  medium: 200,
  slow: 300,
};

export const breakpoints = {
  heightM: 837,
  heightS: 560,
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
};
